import { mergeAttributes, Node } from "@tiptap/core"

/**
 * An icon set into a sentence ("Open the Column Picker [icon] to edit"). The
 * block image node would lift it out of its paragraph and cut the line in two,
 * so `img[data-inline]` parses here first and stays in the text.
 */
export const InlineImageExtension = Node.create({
	name: "inlineImage",
	inline: true,
	group: "inline",
	atom: true,
	draggable: false,

	addAttributes() {
		return {
			src: { default: null },
			alt: { default: null },
			title: { default: null },
		}
	},

	parseHTML() {
		return [{ tag: "img[src][data-inline]", priority: 60 }]
	},

	renderHTML({ HTMLAttributes }) {
		return ["img", mergeAttributes(HTMLAttributes, { "data-inline": "" })]
	},
})
